module.exports = __webpack_public_path__ + "img/19_maska_vog-kvadrat.b7052e3.svg";